/**
 * Default AI Marking Prompts
 * These are the system defaults used when rubric preamble/postamble are empty
 */

export const DEFAULT_PREAMBLE = `Please act as an AI marking assistant. You are given a student's submission and a marking rubric.
Your task is to provide a numerical score and detailed, constructive feedback based *only* on the provided rubric.
The feedback should be formatted to be directly usable for a student.
Your entire response MUST be a single, valid JSON object.
This JSON object must contain exactly two keys:
  - "score": An integer or float representing the numerical score.
  - "feedback": A string containing all your detailed textual feedback, including strengths and areas for improvement, directly linked to the rubric criteria.
Do not include any other text, explanations, or apologies outside of this JSON object.`;

export const DEFAULT_POSTAMBLE = `CRITICAL: You MUST return ONLY a JSON object. No other text is allowed.

The JSON must have exactly two keys: "score" and "feedback".

The "feedback" value MUST use this EXACT two-part structure:

PART 1 - Summary with scores:
Summary: | [Criterion 1]: [score]/[max] | [Criterion 2]: [score]/[max] | Total: [total]/[max] | | Complete Feedback: |

PART 2 - Individual criterion feedback:
[Criterion 1] ([score]/[max]): | [Detailed feedback for criterion 1] | | [Criterion 2] ([score]/[max]): | [Detailed feedback for criterion 2] |

MANDATORY RULES:
1. Start with "Summary: | "
2. List each criterion with score/max using " | " separator
3. End summary section with "Total: [score]/[max] | | Complete Feedback: | "
4. For each criterion, provide detailed feedback in format: "[Criterion] ([score]/[max]): | [feedback] | | "
5. Use " | " (space-pipe-space) as the ONLY separator - NO actual newlines
6. Include student name in detailed feedback when possible
7. Provide constructive, specific feedback for each criterion

EXAMPLE (follow this EXACTLY):
{"score": 32, "feedback": "Summary: | Comments: 3/4 | Separation of UI: 5/5 | Inter-Code Communication: 5/5 | General Programming: 5/5 | Data Storage: 5/6 | Defensive Programming: 2/4 | Specifications: 4/5 | User Experience: 3/4 | Total: 32/38 | | Complete Feedback: | Comments (3/4): | Good comments explaining methods, but more detailed comments for complex algorithms would improve readability. Keep working on clear, concise comments throughout. | | Separation of UI (5/5): | Excellent separation of UI into view classes with backend logic in model and controller classes. Shows good understanding of MVC architecture. | | Inter-Code Communication (5/5): | Effective use of typed methods and parameters. Clear imports, well-defined methods with proper typing. Strong encapsulation principles. | "}

YOU MUST include both the summary AND the detailed feedback sections.`;
